import { React, useEffect, useState, useRef } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useFormik, Form, FormikProvider } from 'formik';

// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    Grid,
    TextareaAutosize,
    Typography,
    Modal,
    Box
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { useSnackbar } from 'notistack';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../Page';
import AppCache from '../../../services/AppCache';

import StickyHeader from "../../Common/StickyHeader";

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};
export default function BiometricCorrection() {
    const TABLE_HEAD = [
        { field: 'SAPLId', headerName: 'SAPL ID', flex: 1 },
        { field: 'Name', headerName: 'Name', flex: 1 },
        { field: 'DepartMent', headerName: 'Department', flex: 1 },
        { field: 'MinHr', headerName: 'Min', width: 300, flex: 1 },
        { field: 'MaxHr', headerName: 'Max', width: 300, flex: 1 },
        { field: 'TotalHrs', headerName: 'Total Hrs', flex: 1 },
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            width: 20,
            renderCell: (cellValues) => {
                return (<div>

                    <IconButton
                        onClick={(event) => {
                            handleClick(event, cellValues);
                        }}><Iconify icon="ic:outline-edit" width='20px' height='20px' color='primary.main' /></IconButton>

                </div>
                );
            }
        },

    ];

    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();
    const [userId, setUserId] = useState('');
    const navigate = useNavigate();

    const [executive, setExecutive] = useState("");
    const [selectExecutive, setSelectExecutive] = useState([]);

    const [isLoading, setIsLoading] = useState();
    // const [effectiveFromValue, setEffectiveFromValue] = useState((new Date()));
    const [effectiveFromValue, setEffectiveFromValue] = useState(new Date(Date.now() - 86400000));

    const [biometricData, setBiometricData] = useState([]);
    const [editBiometricData, setEditBiometricData] = useState([]);

    const [openModal, setOpenModal] = useState(false);
    const [logIn, setLogIn] = useState( "");
    const [logOut, setLogOut] = useState("");
    const [pageSize, setPageSize] = useState(25);

    console.log("edit>>>>>>>>>>>>>", editBiometricData, editBiometricData[0]?.login)

    useEffect(() => {
        const currentUser = AppCache.GetCurrentLoggedInUser();
        const executiveId = currentUser?.ExecutiveId;

        if (executiveId) {
            setUserId(executiveId); 
            URLS.getExecutiveData({ ExecutiveID: executiveId })
                .then((response) => {
                    setSelectExecutive(response.data);
                    setExecutive(executiveId); 
                })
                .catch((error) => {
                    console.log("Error fetching executive data:", error);
                });
        }
    }, []);

    useEffect(() => {
        if (editBiometricData.length > 0) {
            setLogIn(editBiometricData[0].Login?.substring(0, 5) || "");
            setLogOut(editBiometricData[0].Logout?.substring(0, 5) || ""); 
 
        }
    }, [editBiometricData]);

    useEffect(() => {
        setEffectiveFromValue(new Date(Date.now() - 86400000));
        setExecutive('');
        setBiometricData([]);
    }, [location.key]);

    const handleClick = (event, cellValues) => {
        setOpenModal(true);
        const payload = {
            "Date": Moment(effectiveFromValue).format('DD-MMM-YYYY'),
            "ExecutiveId": executive
        }
        URLS.getBiometricAttendance(payload)
            .then((response) => {
                setEditBiometricData(response.data);

            })
            .catch((error) => {
                console.log("Data Not Found", error);
            });

    }

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModal = () => {
        setOpenModal(true);
    }
    const handleExecutive = (event) => {
            setExecutive(event.target.value); 
    };

    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue)
    };
    const handleLogIn = (e) => {
        setLogIn(e.target.value); 
       
    };
    const handleLogOut = (e) => {
        setLogOut(e.target.value);
    }
    const handleFilterChange = () => {
        if (!effectiveFromValue) {
            enqueueSnackbar("Please Select Date");

        }
        const payload = {
            "Date": Moment(effectiveFromValue).format('DD-MMM-YYYY'),
            "ExecutiveId": executive
        }
        URLS.filterBiometricAttendance(payload)
            .then((response) => {
                setBiometricData(response.data);
                enqueueSnackbar("Fetch data successfully", { variant: 'success' });

            })
            .catch((error) => {
                console.log("Data Not Found", error);
            });

    }
    const formik = useFormik({
        initialValues: {
            ExecutiveId: executive || editBiometricData[0]?.ExecutiveId,
            logInTime: logIn,
            logOutTime: logOut
        },
       
         onSubmit: (values, actions) => {
           
             const payload = [
                 {
                     UserID: executive || editBiometricData[0]?.ExecutiveId,
                     PunchDate: Moment(effectiveFromValue).format('DD-MMM-YYYY'),
                     PunchTime: logIn
                 },
                 {
                     UserID: executive || editBiometricData[0]?.ExecutiveId,
                     PunchDate: Moment(effectiveFromValue).format('DD-MMM-YYYY'),
                     PunchTime: logOut
                 }
             ];
             const filterPayload = {
                 "Date": Moment(effectiveFromValue).format('DD-MMM-YYYY'),
                 "ExecutiveId": executive
             }
            console.log("payload>>>>>>>>>", payload)
          
             URLS.saveBiometricAttendance(payload)
                            .then((response) => {
                                if (response.status === 200) {
                               
                                    enqueueSnackbar("Data saved successfully", { variant: 'success' });
                                    setOpenModal(false);
                                  
                                    URLS.filterBiometricAttendance(filterPayload)
                                        .then((response) => {
                                            setBiometricData(response.data);

                                        })
                                        .catch((error) => {
                                            console.log("Data Not Found", error);
                                        });

                                }
                            })
                            .catch(error => {
                                enqueueSnackbar("Data not saved", { variant: 'error' });

                                // handleError(error, enqueueSnackbar);
                            });
                  
        },

    });
    const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

    return (
        <Page title="Biometric Correction" >
            
            <StickyHeader title= "Biometric Correction" />

            <Card >
                <Stack direction="row" alignItems="center" justifyContent="space-between" m={1} mt={2} spacing={1}>

                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker

                            label="From Date"
                            inputFormat="dd/MMM/yyyy"
                            value={Moment(effectiveFromValue).format('DD-MMM-yyyy')}
                            onChange={handleEffFrom}
                            renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                            disableFuture
                        />
                    </LocalizationProvider>
                    <FormControl
                        size="small"
                        fullWidth
                    >
                        <InputLabel inputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Executive</InputLabel>
                        <Select
                            label="Executive"
                            size="small"
                            value={executive}
                           
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: '#fbe9e7',
                                        maxHeight: '200px',
                                    },
                                },
                            }}
                            onChange={handleExecutive}
                        >
                            <MenuItem key={0} value={""} >Select</MenuItem>

                            {selectExecutive.map((ex) => (
                                <MenuItem
                                    key={ex.Id}
                                    value={ex.Id}
                                >
                                    {ex.Name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    
                    <Modal open={openModal} onClose={handleOpenModal}>
                        <Box sx={modalStyle}>
                            <FormikProvider value={formik}>
                            <Form autoComplete="off" noValidate onSubmit={handleSubmit} >
                            <Stack spacing={3}>
                                {/* Client Remark */}
                                <Typography variant="h7" >
                                            Employee Name : {editBiometricData[0]?.ExecutiveName }
                                </Typography>
                              
                                    <TextField
                                        size="small"
                                        label="Log In"
                                        value={logIn}
                                        onChange={handleLogIn}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{ maxLength: 5 }}
                                        fullWidth
                                    />
                                 
                                <TextField
                                    size="small"
                                    type="text"
                                    label="Log Out"
                                    value={logOut}
                                    onChange={handleLogOut}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{ maxLength: 5 }}
                                    fullWidth
                                        />

                                <Stack direction="row" justifyContent="center" spacing={2} mt={4}>
                                    <LoadingButton
                                    
                                        size="medium"
                                        type="submit"
                                        variant="contained"
                                        sx={{ color: "white" }}

                                    >
                                        Save
                                    </LoadingButton>
                                    <Button
                                        sx={{ color: "white" }}
                                        size="medium"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleCloseModal}
                                    >
                                        Cancel
                                    </Button>
                                </Stack>
                                </Stack>
                                </Form>
                            </FormikProvider>
                        </Box>
                    </Modal>

                    <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="space-between" spacing={1}>

                        <Tooltip title="Filter">

                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleFilterChange}

                            ><Icon icon="ic:outline-filter-alt" width="25px" height="25px" /></Button>
                        </Tooltip >
                

                    </Stack>
                </Stack>

                <Divider />

                {/* ----------------------------------------------------------------- */}

                <div style={{ height: '70vh', width: '100%' }}>
                    <DataGrid rows={biometricData} density={'compact'} columns={TABLE_HEAD} getRowId={(row) => biometricData.indexOf(row)}
                        rowsPerPageOptions={[25, 50, 100]} pageSize={pageSize} onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}  components={{ Toolbar: GridToolbar, }} />
                </div>

            </Card>
            {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}


        </Page>
    );

}